module.exports = __webpack_public_path__ + "img/logo_dldebt.ba93a018.png";